// Phase A — outreach-link college capture.
//
// The Try-for-Free link carries ?college=<slug>. We stash it in localStorage the
// moment the student lands, so it survives the redirect to /register AND the
// Google OAuth round-trip (which wipes URL params). After sign-in, AuthContext
// sends it to /api/users/sync, which writes users.college (validated against the
// canonical directory). Works for both Google and email signups.

const KEY = 'f2c_college';

/** Read ?college=<slug> from the current URL and persist it. Safe to call anywhere. */
export function captureCollegeFromUrl() {
  try {
    const c = new URLSearchParams(window.location.search).get('college');
    if (c && /^[a-z0-9-]{2,80}$/i.test(c)) {
      localStorage.setItem(KEY, c.toLowerCase());
    }
  } catch {
    /* no-op */
  }
}

export function getStoredCollege() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

export function clearStoredCollege() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* no-op */
  }
}
